import {
  CompleteTimeColumn,
  IssueTitleColumn,
  EmergencyColumn,
  OrderTimeColumn,
  PriceColumn,
  ViewColumn,
  FlagColumn,
} from 'views/Billing/commonColumns';
import { getIssuePriority } from 'shared/constants/issues';
import logger from 'utils/logger';

const log = logger.createLogger('kenshinTableSentBilling');

export const kenshinTableColumns = (openIssue) => [
  IssueTitleColumn(),
  EmergencyColumn(),
  OrderTimeColumn(),
  CompleteTimeColumn(),
  PriceColumn(),
  ViewColumn(openIssue),
  FlagColumn(),
];

export const getKenshinTableData = (
  billData,
  selectedDstOrgId,
  selectedBillingMonth
) => {
  const bills = billData.find(
    (bill) =>
      bill.orgId === selectedDstOrgId &&
      bill.billedMonthYear === selectedBillingMonth
  );
  if (!bills) return [];
  const billsData = bills.bills;

  billsData.sort((a, b) => a.createdAt - b.createdAt);

  const tableData = billsData.map((bill) => {
    const {
      id,
      issueCreatedAt,
      createdAt,
      issueId,
      issueTitle,
      issuePriority,
      originalFee,
      currentFee,
      starred,
    } = bill;

    return {
      issueTitle: issueTitle,
      emergency: getIssuePriority(issuePriority),
      orderTime: issueCreatedAt,
      completeTime: createdAt,
      price: {
        originalFee: originalFee,
        currentFee: currentFee,
      },
      view: {
        billId: id,
        issueId: issueId,
      },
      flag: starred,
    };
  });

  return tableData;
};
